import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Ваш лимит по займу можно увеличить!',
  action: 'Увеличить лимит',
} satisfies TMessages
